import { render, staticRenderFns } from "./preSale-order-delivery.vue?vue&type=template&id=136473f2&scoped=true"
import script from "./preSale-order-delivery.vue?vue&type=script&lang=js"
export * from "./preSale-order-delivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136473f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('136473f2')) {
      api.createRecord('136473f2', component.options)
    } else {
      api.reload('136473f2', component.options)
    }
    module.hot.accept("./preSale-order-delivery.vue?vue&type=template&id=136473f2&scoped=true", function () {
      api.rerender('136473f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/preSale-management/preSale-order/preSale-order-delivery.vue"
export default component.exports